import React from 'react';
import Icon from '../Partials/Icon';

class ShareButton extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            open: false,
        }

        this.toggleOpen = this.toggleOpen.bind(this);
        this.handleScroll = this.handleScroll.bind(this);
    }

    componentDidMount() {
        window.addEventListener('scroll', this.handleScroll);
    }

    handleScroll() {
        // Close the open state
        if (this.state.open) {
            this.setState({
                open: false,
            });
        }
    }

    toggleOpen(e) {
        e.preventDefault();

        this.setState({
            open: !this.state.open,
        });
    }

    render() {
        const postUrl = window.location.origin + this.props.post.url;
        const blogName = window.blogTitle ?? 'den här bloggen';

        return (
            <React.Fragment>
                <div className={`post_share_button ${this.props.className ?? ''}${this.state.open ? ' post_share_button--open' : ''}`}>
                    <div className="post_share_button__wrapper">
                        <a href="#" onClick={this.toggleOpen}>
                            { !this.state.open ? (
                                <Icon type="share_circle" />
                            ) : (
                                <Icon type="close_circle" />
                            )
                            }
                        </a>
                        { this.state.open && 
                            <div className="post_share_button__menu">
                                {/* Mail */}
                                <a href={`mailto:someone@domain.com?subject=${encodeURIComponent(`Bloggtips från ${blogName}`)}&body=${encodeURIComponent(`Hej,\nJag vill tipsa dig om ett blogginlägg från ${blogName}:\n${postUrl}`)}`} className="share_button share_button--mail">
                                    <span>Maila</span>
                                    <Icon type="mail_circle" />
                                </a>

                                {/* Pinterest */}
                                <a href={`${window.location.origin}/predirect/?url=${encodeURIComponent(postUrl)}`} 
                                    className="share_button share_button--pin" target="_blank">
                                    <span>Pinterest</span>
                                    <Icon type="pinterest_circle" />
                                </a>

                                {/* X (Twitter) */}
                                <a href={`https://x.com/share?url=${encodeURI(postUrl)}`} 
                                    className="share_button share_button--x" target="_blank">
                                    <span>X</span>
                                    <Icon type="x_circle" />
                                </a>

                                {/* Facebook */}
                                <a href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURI(postUrl)}`} 
                                    // (TODO:share) Check if we want to use this instead in the future
                                    // onClick={() => {window.open(this.href, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600');return false;}}
                                    className="share_button share_button--facebook" target="_blank">
                                    <span>Facebook</span>
                                    <Icon type="facebook_circle" />
                                </a>

                                {/* Bloglovin */}
                                {typeof window.blogLovin !== 'undefined' &&
                                <a title="Följ på Bloglovin" href={`${window.blogLovin}`}
                                    className="social_share__item social_share__item-blogLovin"  target="_blank">
                                    <Icon type="bloglovin_square" />
                                </a>
                                }

                                {this.props.post.meta_data.hide_comments != "1" && 
                                    <a href="#" className="share_button share_button--comment" onClick={this.props.showComments}>
                                        <span>Kommentera</span>
                                        <Icon type="comment_circle" />
                                    </a>
                                }
                            </div>
                        }
                    </div>
                </div>
                { this.state.open && 
                    <div className="post_share_button__overlay" onClick={this.toggleOpen}></div>
                }
            </React.Fragment>
        );
    }
}

export default ShareButton;